import {React,useState} from "react";

import "./App.css";
import WhatsappLogo from '../images/whatsapp-icon.png';
import InstagramLogo from '../images/insta-icon.png';
import TiktokLogo from '../images/tiktok-icon.png';
import GymHouseLogo from '../images/gymHouse-logo.png';
import GoogleMapsLogo from '../images/GoogleMaps-icon.png';
import { useNavigate } from "react-router-dom";
import {  Button, Row,  Form } from "react-bootstrap";

export default function NutritionistsApplyForm() {
  const navigate = useNavigate();
  

  const [firstName,setFirstName] = useState('')
  const [lastName,setLastName] = useState('')  
  const [certificationSource,setCertificationSource] = useState('')
  const [yearOfExperience,setYearOfExperience] = useState('')  
  const [howDoIStartWorkout,setHowDoIStartWorkout] = useState('')
  const [whyDoILikeToTrain,setWhyDoILikeToTrain] = useState('')  
  const [whatIsMyGoal,setWhatIsMyGoal] = useState('')
  const [mainReasonToJoinTheFamily,setMainReasonToJoinTheFamily] = useState('')  
  const [comments,setComments] = useState('')
const [url,setUrl] = useState('')
function handleSubmit(){
  var addingStrings="hello team i am ";
  addingStrings=addingStrings+firstName+" "+lastName + " I am certified from " +certificationSource+" and I have "+ yearOfExperience +" years of experience "
  if(howDoIStartWorkout !== '')
  addingStrings=addingStrings+" ,how do i start workout: "+howDoIStartWorkout
  if(whyDoILikeToTrain !== '')
  addingStrings=addingStrings+" ,why do i like to train: "+whyDoILikeToTrain
  if(whatIsMyGoal !== '')
  addingStrings=addingStrings+" ,what is my goal: "+whatIsMyGoal
  if(mainReasonToJoinTheFamily !== '')
  addingStrings=addingStrings+" ,Main reason to join the family: "+mainReasonToJoinTheFamily
  if(comments !== '')
  addingStrings=addingStrings+" ,additional Comments: "+comments
  
  addingStrings=addingStrings+" !! Thank you."
  setUrl( addingStrings
  )
    
 if(firstName!==''&&lastName!==''&&certificationSource!==''&&yearOfExperience!=='')
 {
  
  openInNewTab("https://wa.me/+96171453095?text="+addingStrings)
  }

}
const openInNewTab = (url) => {
  window.open(url, "_blank", "noreferrer");
};

    
    return (
     
        
        
            <div className="default-page">
            <img onClick={()=>{navigate('/')}} alt="Welcome to GymHouse" className="gymHouse-Logo" src={GymHouseLogo}></img>
              <h1><b>Welcome To Our Family</b></h1>
              <div className="spacer"></div>
              <div className="spacer"/>
              <h2><b>Join us!</b></h2>
              <div className="spacer"/>
              <div className="spacer"/>
              <hr/>
              <Form  id="coachForm" >
            
              <Row sm={4}>
                <Form.Group controlId="FirstName">
                  <Form.Label className="FormLabel">FirstName<font COLOR="#ff0000">*</font></Form.Label>
                  <Form.Control                                     
                    type="text"
                    required
                    onChange={(e)=>setFirstName(e.target.value)}
                    name="FirstName"
                    id="FirstName"
                  ></Form.Control>
                </Form.Group>
                <Form.Group controlId="LastName">
                  <Form.Label className="FormLabel">
                    LastName<font COLOR="#ff0000">*</font>
                  </Form.Label>
                  <Form.Control
                    type="text"                    
                    name="LastName"
                    onChange={(e)=>setLastName(e.target.value)}
                    required
                  ></Form.Control>
                </Form.Group>
                
                <Form.Group controlId="Certification Source">
                  <Form.Label className="FormLabel">Certification Source<font COLOR="#ff0000">*</font></Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="Certification Source"
                    onChange={(e)=>setCertificationSource(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                <Form.Group controlId="Years of experience">
                  <Form.Label className="FormLabel">Years of experience<font COLOR="#ff0000">*</font></Form.Label>
                  <Form.Control
                    type="text"
                    required
                    name="Years of experience"
                    onChange={(e)=>setYearOfExperience(e.target.value)}
                  ></Form.Control>
                </Form.Group>
                
              </Row>

             
              <Row >
                <Form.Group controlId="How do i start workout">
                  <Form.Label className="FormLabel">How do i start workout?</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e)=>setHowDoIStartWorkout(e.target.value)}
                    name="How do i start workout"
                  ></Form.Control>
                </Form.Group>
                </Row>
                <Row >
                <Form.Group controlId="Why do i like to train">
                  <Form.Label className="FormLabel">Why do i like to train?</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e)=>setWhyDoILikeToTrain(e.target.value)}
                    name="Why do i like to train"
                  ></Form.Control>
                </Form.Group>
                </Row>
                <Row >
                <Form.Group controlId="What is my goal">
                  <Form.Label className="FormLabel">What is my goal?</Form.Label>
                  <Form.Control
                    type="text"
                    onChange={(e)=>setWhatIsMyGoal(e.target.value)}
                    name="What is my goal"
                  ></Form.Control>
                </Form.Group>
                </Row>
              
            
            <Row>
              <Form.Group controlId="Main reason to join the family">
                <Form.Label className="FormLabel">Main reason to join the family</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e)=>setMainReasonToJoinTheFamily(e.target.value)}
                  name="Main reason to join the family"
                ></Form.Control>
              </Form.Group>
              <Form.Group controlId="Comments">
                <Form.Label className="FormLabel">Comments</Form.Label>
                <Form.Control
                  type="text"
                  onChange={(e)=>setComments(e.target.value)}
                  name="Comments"
                ></Form.Control>
              </Form.Group>
            </Row>
            
            <br />
            
            <p className="red">By clicking submit you will be sending all your details to our team on whatsapp</p>
              <Button variant="primary" type="submit" onClick={handleSubmit}>
                Submit
              </Button>

 
 

              
              {/* <div className='spacer'></div>
                         <Button variant="danger" onClick={this.heandleResetCase}>مسح البيانات</Button> */}
           
          </Form>
                <div className="spacer"/>
                
                <div className="spacer"/>
                <hr/>
                <h2><b>You can reach us here</b></h2>
                <div className="icons-container">
                  {/* ?text=hello world */}
                <li><a id="whatsappLink" target="blank" href={"https://wa.me/+96171453095?text="+url} ><img alt="Reach us on Whatsapp" className="icons" src={WhatsappLogo}></img></a></li>
                <li><a target="blank" href="https://www.instagram.com/gymhouse_lb?igsh=MWpsaGZzOXppM3I5Zg%3D%3D&utm_sourc`e=qr"><img alt="Reach us on Instagram" className="icons" src={InstagramLogo}></img></a> </li>
                <li><a target="blank" href="https://www.tiktok.com/@gymhouse_lb?_t=8j1PECEQvuE&_r=1"><img alt="Reach us on Tiktok" className="icons" src={TiktokLogo}></img></a> </li>
                <li><a target="blank" href="https://maps.app.goo.gl/JEc6kySrX7HA9N1S8 " ><img alt="Find us on GoogleMaps" className="icons" src={GoogleMapsLogo}></img></a></li>
                
                </div>
                <hr/>
                
             
              
              </div>
                            
           
          

         
         

        
    );
  }

